import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';
import { ContactRow } from '../components/ContactRow';
import { NameRow } from '../components/NameRow';
import { RolesRow } from '../components/RolesRow';

/** The Profile tab: who you are and where your sign-in codes go. It reads the signed-in user, so there is nothing to load. */
export function ProfilePage() {
  const { state } = useCurrentUser();
  if (state.status !== 'authenticated') return null;
  const { user } = state;

  return (
    <dl className="max-w-2xl divide-y divide-line rounded-lg border border-line bg-surface">
      <NameRow name={user.name} />
      <ContactRow kind="email" label="Email" current={user.email} />
      <ContactRow kind="phone" label="Mobile" current={user.phone} />
      <RolesRow roles={user.roles} />
    </dl>
  );
}
